import type { Country, Dictionary } from '@types'

import { dictionaries } from '@lib/constants'

export default function getDictionary(locale: string): Dictionary {
  return ['us', 'uk'].includes(locale) ? dictionaries[locale as Country] : dictionaries.us
}
